// extracted by mini-css-extract-plugin
module.exports = {"space":"style_space__0Cs9z"};